import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, CardTitle, FormGroup, Spinner} from "reactstrap";
import { useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import { getAccountUserData } from 'store/actions';
import {
    Form,
    Input,
    InputGroup,
    Label,
    NavItem,
    NavLink,
   
   
    Button,
    TabContent,
    TabPane,
    FormFeedback,
  } from "reactstrap"

  
//validtions
// Formik validation
import * as Yup from "yup";
import { useFormik, yupToFormErrors } from "formik";
import classnames from "classnames"
import { Link } from "react-router-dom"
import { 
    AddNewUser,
    ClearAddUser
} from "store/actions";


const ViewUserData = () => {



  ////channellist
  const [channellist,setChannel]=useState([
    {channelName:"Content Stratergy Process"},
    {channelName:"Paid Media"},
    {channelName:"Organic Social Media"},
    {channelName:"Website"}, 
    {channelName:"Digital Events/Webinar"},
    {channelName:"Analytics"},
    {channelName:"SEO"},
    {channelName:"Public Relations"},
    {channelName:"Marketing Automation"},
    {channelName:"Blogs"},
    {channelName:"Email"},
   
   
])

   
  // ]);


  
    const params = useParams()


    //Additional States for handleing custom requests:
    const [isUserAdded, setIsUserAdded] = useState(false)
    // validations
    const validation = useFormik({
     
        enableReinitialize: true,

        initialValues: {
            ScorecardFileName:'',
            CompanyName:'',
            ContactName:'',
            Phone:'',
            Email:'',
            CompanyAddress1:'',
            CompanyAddress2:'',
            AnnualRevenue:'',
            Country:'',
            NumberOfEmployee:'',
            Industry:'',
            WebsiteURl:'',
            Ownership:'',
            ClientAttribute1:'',
            ClientAttribute2:'',
            CountryCode:'+91',
            SelectAccountUser:'',
        },

 validationSchema: Yup.object({
    ScorecardFileName: Yup.string().required("enter scorecard file name"),
    CompanyName: Yup.string().required("enter company name"),
    ContactName: Yup.string().required("enter contact name"),
   Phone: Yup.string().max(10, "Contact number must be atleast 10 digits!").min(10, "Contact number must be atleast 10 digits!").required("Please enter contact number!"),
    Email: Yup.string().required("enter valid Email"),
    CompanyAddress1:Yup.string().required("enter company address"),
    CompanyAddress2:Yup.string().required("enter company address"),
    AnnualRevenue:Yup.string().required("annual revenue"),
    Country:Yup.string().required("enter country/state name"),
    NumberOfEmployee:Yup.string().required("enter number Of employee"),
    Industry:Yup.string().required("name ofindustry"),
    WebsiteURl:Yup.string().required("website URL"),
    Ownership:Yup.string().required("ownership"),
    ClientAttribute1:Yup.string().required("client attribute 1"),
    ClientAttribute2:Yup.string().required("client attribute 2"),  
    SelectAccountUser:Yup.string().required("select account user"),
   
 }),

 onSubmit: (values) => {
    var date = new Date()
    var user = JSON.parse(localStorage.getItem("authUser"))

    var myUserData = {
       ScorecardFileName:values.ScorecardFileName,
       CompanyName:values.CompanyName,
       ContactName:values.ContactName,
       Phone: values.Phone,
       Email:values.Email,
       CompanyAddress1:values.CompanyAddress1,
       CompanyAddress2:values.CompanyAddress2,
       AnnualRevenue:values.AnnualRevenue,
       Country:values.Country,
       NumberOfEmployee:values.NumberOfEmployee,
       Industry:values.Industry,
       WebsiteURl:values.WebsiteURl,
       Ownership:values.Ownership,
       ClientAttribute1:values.ClientAttribute1,
       ClientAttribute2:values.ClientAttribute2,
       CountryCode:values.CountryCode,
       SelectAccountUser:values.SelectAccountUser,
        isDisabled: false
    }
    setIsUserAdded(true)
    dispatch(AddNewUser(myUserData))
    
}
 
 
    });
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title> Create Scorecard  | MAMBO</title>
                    </MetaTags>
                  
                    <Container fluid={true}>
                    
                    <Row>
                    <Col xl="12" style={{margin: "auto"}}>
                    <Card>
                                <CardBody>

                    
                  
                  <Form className="needs-validation outer-repeater"
                                        onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                        }}>
                   {/* <Row>
                   
                
                    <h4 className="card-title" style={{textTransform: ""}}>Create New Scorecard </h4>
                
                    
                </Row><br></br> */}
                    <Row>
                    <Col md="6">
                                <FormGroup className="mb-3">
                                 <label>Scorecard File Name</label>
                                  <Input
                                  name="ScorecardFileName"
                                  placeholder='scorecard file name'
                                    type="text"
                                    className="form-control"
                                    id="txtScorecardFileName"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.ScorecardFileName || ""}
                                    invalid={
                                      validation.touched.ScorecardFileName && validation.errors.ScorecardFileName ? true : false
                                    }
                                  />
                                  {validation.touched.ScorecardFileName && validation.errors.ScorecardFileName? (
                                    <FormFeedback type="invalid">{validation.errors.ScorecardFileName}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>
                              <Col md="6">
                <FormGroup className="mb-3">
                  <label>Select Account User</label>
                  <Input type="select"
                className="form-select"
                  name="SelectAccountUser"
                  onChange={validation.handleChange}
                 invalid={
               validation.touched.SelectAccountUser && validation.errors.SelectAccountUser ? true : false
                 } value={validation.values.SelectAccountUser|| ""}>
                                  
            <option value="">account user</option>
          <option value="1">Sourabh</option>
             <option value="2">Pratik</option>
              <option value="3">Gaourav</option>
            </Input>
            {validation.touched.SelectAccountUser && validation.errors.SelectAccountUser ? (
        <FormFeedback type="invalid">{validation.errors.SelectAccountUser}</FormFeedback>
     ) : null}
         </FormGroup>
              </Col>   
                    </Row><br></br>
                    <Row>
                    
                
                    <h4 className="card-title" style={{color:"Background"}}  >Client Information</h4>
                
                     
                    </Row><br></br>
                   
                    <Row>
                    <Col md="4">
                                <FormGroup className="mb-3">
                                 <label>Company Name</label>
                                  <Input
                                  name="CompanyName"
                                  placeholder="company name"
                                    type="text"
                                    className="form-control"
                                    id="txtCompanyName"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.CompanyName || ""}
                                    invalid={
                                      validation.touched.CompanyName && validation.errors.CompanyName ? true : false
                                    }
                                  />
                                  {validation.touched.CompanyName && validation.errors.CompanyName? (
                                    <FormFeedback type="invalid">{validation.errors.CompanyName}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>  
                              <Col md="4">
                                <FormGroup className="mb-3">
                                 <label>Contact Name</label>
                                  <Input
                                  name="ContactName"
                                  placeholder="contact name"
                                    type="text"
                                    className="form-control"
                                    id="txtContactName"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.ContactName || ""}
                                    invalid={
                                      validation.touched.ContactName && validation.errors.ContactName ? true : false
                                    }
                                  />
                                  {validation.touched.ContactName && validation.errors.ContactName? (
                                    <FormFeedback type="invalid">{validation.errors.ContactName}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>  
                              <Col md = "1" >
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="validationCustom01"> Code</Label>
                                                            <select
                                                             className="form-control"
                                                             name="CountryCode"
                                                             disabled = { isUserAdded }
                                                             value = { validation.values.CountryCode }
                                                             onChange = { validation.handleChange }
                                                            >
                                                                <option value = "+91" >+91</option>
                                                                <option value = "+52" >+52</option>

                                                            </select>
                                                           
                                                            {validation.touched.CountryCode && validation.errors.CountryCode ? (
                                                                <FormFeedback type="invalid">{validation.errors.CountryCode}</FormFeedback>
                                                            ) : null}
                                                    </FormGroup>
                                                </Col>
                 
                          
                                                <Col md = "3" >
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="validationCustom01">Phone</Label>
                                                            <Input
                                                            name="Phone"
                                                            placeholder="phone"
                                                            type="number"
                                                            min= "1"
                                                            style = { {
                                                                MozAppearance: "none"
                                                            } }
                                                            className="form-control"
                                                            disabled = { isUserAdded }
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.Phone || ""}
                                                            invalid={
                                                            validation.touched.Phone && validation.errors.Phone ? true : false
                                                            }
                                                            />
                                                            {validation.touched.Phone && validation.errors.Phone ? (
                                                                <FormFeedback type="invalid">{validation.errors.Phone}</FormFeedback>
                                                            ) : null}
                                                    </FormGroup>
                                                </Col>           
                    </Row>
                
                 <Row>
                 <Col md="4">
                                <FormGroup className="mb-3">
                                 <label>Company Address</label>
                                  <Input
                                  name="CompanyAddress1"
                                  placeholder="line 1"
                                    type="text"
                                    className="form-control"
                                    id="txtCompanyAddress1"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.CompanyAddress1 || ""}
                                    invalid={
                                      validation.touched.CompanyAddress1 && validation.errors.CompanyAddress1  ? true : false
                                    }
                                  />
                                  {validation.touched.CompanyAddress1 && validation.errors.CompanyAddress1? (
                                    <FormFeedback type="invalid">{validation.errors.CompanyAddress1}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>   
                              
                            <Col md="4">
                                <FormGroup className="mb-3">
                                <label> Company Address </label>
                                  <Input
                                  name="CompanyAddress2"
                                  placeholder="line 2"
                                    type="text"
                                    className="form-control"
                                    id="txtCompanyAddress2"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.CompanyAddress2 || ""}
                                    invalid={
                                      validation.touched.CompanyAddress2 && validation.errors.CompanyAddress2  ? true : false
                                    }
                                  />
                                  {validation.touched.CompanyAddress2 && validation.errors.CompanyAddress2? (
                                    <FormFeedback type="invalid">{validation.errors.CompanyAddress2}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>   
                 
                              <Col md="4">
                                <FormGroup className="mb-3">
                                 <label>Email</label>
                                  <Input
                                  name="Email"
                                  placeholder="email"
                                    type="text"
                                    className="form-control"
                                    id="txtEmail"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Email || ""}
                                    invalid={
                                      validation.touched.Email && validation.errors.Email  ? true : false
                                    }
                                  />
                                  {validation.touched.Email && validation.errors.Email? (
                                    <FormFeedback type="invalid">{validation.errors.Email}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>
                                                       
                 </Row>
                 
                 <Row>
                 <Col md="4">
                <FormGroup className="mb-3">
                  <label>Annual Revenue</label>
                  <Input type="select"
                className="form-select"
               
                  name="AnnualRevenue"
                  onChange={validation.handleChange}
                 invalid={
               validation.touched.AnnualRevenue && validation.errors.AnnualRevenue ? true : false
                 } value={validation.values.AnnualRevenue|| ""}>
                                  
            <option value="">choose</option>
          <option value="1">less than 100000</option>
             <option value="2">less than 500000</option>
              <option value="3">less than 1000000</option>
            </Input>
            {validation.touched.AnnualRevenue && validation.errors.AnnualRevenue ? (
        <FormFeedback type="invalid">{validation.errors.AnnualRevenue}</FormFeedback>
     ) : null}
         </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup className="mb-3">
          <label>State/Country</label>
          <Input type="select"
          className="form-select"
             name="country"
         onChange={validation.handleChange}
         invalid={
   validation.touched.Country && validation.errors.Country ? true : false
         } value={validation.values.Country|| ""}>
                                  
          <option value="">choose</option>
           <option value="1">India</option>
          <option value="2">America</option>
          <option value="3">Britain</option>
           <option value="3">Russia</option>
          </Input>
        {validation.touched.Country && validation.errors.Country ? (
    <FormFeedback type="invalid">{validation.errors.Country}</FormFeedback>
         ) : null}
        </FormGroup>
             </Col>
             <Col md="4">  <FormGroup className="mb-3">
       <label>Number Of Employee</label>
            <Input type="select"
                 className="form-select"
            name="NumberOfEmployee"
             onChange={validation.handleChange}
             invalid={
           validation.touched.NumberOfEmployee && validation.errors.NumberOfEmployee ? true : false
         } value={validation.values.NumberOfEmployee|| ""}>
          <option value="">choose</option>
         <option value="1">upto 100</option>
  <option value="2">upto 200</option>
     <option value="3">upto 500</option>
    <option value="3">upto 1000</option>
          </Input>
           {validation.touched.NumberOfEmployee && validation.errors.NumberOfEmployee ? (
        <FormFeedback type="invalid">{validation.errors.NumberOfEmployee}</FormFeedback>
         ) : null}
      </FormGroup>
      </Col>
   </Row>
   <Row>
  
      <Col md="4">
      <FormGroup className="mb-3">
        <label>Industry</label>
       <Input type="select"
        className="form-select"
      name="Industry"
     onChange={validation.handleChange}
    invalid={
  validation.touched.Industry && validation.errors.Industry ? true : false
 } value={validation.values.Industry|| ""}>
                                  
    <option value="">choose</option>
  <option value="1">Telecommunication</option>
    <option value="2">Real Istate</option>
 <option value="3">Fianance</option>
     <option value="3">Defence</option>
        </Input>
        {validation.touched.Industry && validation.errors.Industry ? (
   <FormFeedback type="invalid">{validation.errors.Industry}</FormFeedback>
      ) : null}
      </FormGroup>
      </Col>
      <Col md="4">
               <FormGroup className="mb-3">
              <label>Website URL</label>
                  <Input
          name="WebsiteURl"
        placeholder="Website URL"
              type="text"
              className="form-control"
              id="txtWebsiteURl"
              onChange={validation.handleChange}
                 onBlur={validation.handleBlur}
            value={validation.values.WebsiteURl || ""}
     invalid={
            validation.touched.WebsiteURl && validation.errors.WebsiteURl  ? true : false
                }
              />
           {validation.touched.WebsiteURl && validation.errors.WebsiteURl? (
      <FormFeedback type="invalid">{validation.errors.WebsiteURl}</FormFeedback>
            ) : null}
              </FormGroup>
                </Col>
                
              <Col md="4">
              <FormGroup className="mb-3">
          <label>Ownership</label>
              <Input type="select"
              className="form-select"
              name="Ownership"
            onChange={validation.handleChange}
                invalid={
                 validation.touched.Ownership && validation.errors.Ownership? true : false
             } value={validation.values.Ownership|| ""}>
                                  
             <option value="">choose</option>
               <option value="1">Tata</option>
            <option value="2">Reliance</option>
             <option value="3">Bajaj</option>
             <option value="3">Maruti</option>
             </Input>
              {validation.touched.Industry && validation.errors.Industry ? (
              <FormFeedback type="invalid">{validation.errors.Industry}</FormFeedback>
            ) : null}
             </FormGroup>
            </Col>   


   </Row>
   
   <Row>
   <Col md="4">
       <FormGroup className="mb-3">
         <label> Client Attribute 1</label>
          <Input
             name="ClientAttribute1"
             placeholder="client attribute 1"
             type="text"
            className="form-control"
                id="txtClientAttribute1"
              onChange={validation.handleChange}
               onBlur={validation.handleBlur}
                value={validation.values.ClientAttribute1 || ""}
                  invalid={
      validation.touched.ClientAttribute1 && validation.errors.ClientAttribute1  ? true : false
                                    }
                                  />
                                  {validation.touched.ClientAttribute1 && validation.errors.ClientAttribute1? (
                                    <FormFeedback type="invalid">{validation.errors.ClientAttribute1}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                 <label> Client Attribute 2</label>
                                  <Input
                                  name="ClientAttribute2"
                                  placeholder="client attribute 2"
                                    type="text"
                                    className="form-control"
                                    id="txtClientAttribute2"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.ClientAttribute2 || ""}
                                    invalid={
                                      validation.touched.ClientAttribute2 && validation.errors.ClientAttribute2  ? true : false
                                    }
                                  />
                                  {validation.touched.ClientAttribute2 && validation.errors.ClientAttribute2? (
                                    <FormFeedback type="invalid">{validation.errors.ClientAttribute2}</FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </Col>      
   </Row><br></br>
   <Row>
     
       <div className="title"><label>Channel List</label></div>
         {channellist.map( (channel,index)=>
       (
       
          <div className='col-lg-3' key={index}><br></br>
             <input value={channel} type="checkbox" />
             {channel.channelName}
              
          </div>
       )
       )}
     
     </Row><br></br>
   
 <Row>
     <Col md="8"></Col>
     <Col md="2">
     <FormGroup className="mb-3">
     <Button color="danger" onClick={ () => {
                                                        
      } }
      block >
     Cancel       
  </Button>
    </FormGroup>
        </Col>
         <Col md="2">
        <FormGroup className="mb-3">
         <Button color="primary" type="submit"
         
         block >
                                                    
       Start Survey
                                                     
      </Button>
         </FormGroup>
      </Col>
     </Row>
     
    
    </Form>                                    
 </CardBody>
                            </Card>
                            </Col>
                            </Row>
                    </Container>
                </div>
            </>
        );




}

export default ViewUserData;